<nz-layout>
  <nz-sider
    nzCollapsible
    [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null"
    [nzWidth]="256"
    [nzCollapsedWidth]="64">
    <div class="logo">
      <i nz-icon nzType="database" nzTheme="outline"></i>
      <span *ngIf="!isCollapsed">资料管理系统</span>
    </div>
    <ul nz-menu nzTheme="dark" nzMode="inline">
      <li nz-menu-item routerLink="/home/userAccountManagement" [nzMatchRouter]="true">
        <i nz-icon nzType="user" nzTheme="outline"></i>
        <span>管理员用户</span>
      </li>
      <li nz-menu-item routerLink="/home/expressManagement" [nzMatchRouter]="true">
        <i nz-icon nzType="car" nzTheme="outline"></i>
        <span>快递物流</span>
      </li>
      <li nz-menu-item routerLink="/home/logisticsManagement" [nzMatchRouter]="true">
        <i nz-icon nzType="dollar" nzTheme="outline"></i>
        <span>邮费管理</span>
      </li>
      <li nz-menu-item routerLink="/home/distanceManagement" [nzMatchRouter]="true">
        <i nz-icon nzType="home" nzTheme="outline"></i>
        <span>配送上门</span>
      </li>
      <li nz-submenu nzIcon="setting" nzTitle="商品管理">
        <ul>
          <li nz-menu-item routerLink="/home/brandManagement" [nzMatchRouter]="true">
            <i nz-icon nzType="shop" nzTheme="outline"></i>
            <span>品牌管理</span>
          </li>
          <li nz-menu-item routerLink="/home/categoryManagement" [nzMatchRouter]="true">
            <i nz-icon nzType="appstore" nzTheme="outline"></i>
            <span>品类管理</span>
          </li>
          <li nz-menu-item routerLink="/home/unitManagement" [nzMatchRouter]="true">
            <i nz-icon nzType="border" nzTheme="outline"></i>
            <span>计量单位</span>
          </li>
          <li nz-menu-item routerLink="/home/goodsManagement" [nzMatchRouter]="true">
            <i nz-icon nzType="shopping-cart" nzTheme="outline"></i>
            <span>商品管理</span>
          </li>
          <li nz-menu-item routerLink="/home/goodsCodeManagement" [nzMatchRouter]="true">
            <i nz-icon nzType="barcode" nzTheme="outline"></i>
            <span>商品条码</span>
          </li>
          <li nz-menu-item routerLink="/home/skuManagement" [nzMatchRouter]="true">
            <i nz-icon nzType="tag" nzTheme="outline"></i>
            <span>SKU管理</span>
          </li>
          <li nz-menu-item routerLink="/home/goodsDetailImgManagement" [nzMatchRouter]="true">
            <i nz-icon nzType="picture" nzTheme="outline"></i>
            <span>商品详情图片</span>
          </li>
          <li nz-menu-item routerLink="/home/goodsDetailPropertyManagement" [nzMatchRouter]="true">
            <i nz-icon nzType="layout" nzTheme="outline"></i>
            <span>商品详情参数</span>
          </li>
        </ul>
      </li>
      <li nz-submenu nzIcon="setting" nzTitle="服务项目管理">
        <ul>
          <li nz-menu-item routerLink="/home/serviceBrandManagement" [nzMatchRouter]="true">
            <i nz-icon nzType="shop" nzTheme="outline"></i>
            <span>服务品牌管理</span>
          </li>
          <li nz-menu-item routerLink="/home/serviceCategoryManagement" [nzMatchRouter]="true">
            <i nz-icon nzType="appstore" nzTheme="outline"></i>
            <span>服务品类管理</span>
          </li>
          <li nz-menu-item routerLink="/home/serviceUnitManagement" [nzMatchRouter]="true">
            <i nz-icon nzType="border" nzTheme="outline"></i>
            <span>服务计量单位</span>
          </li>
          <li nz-menu-item routerLink="/home/serviceGoodsManagement" [nzMatchRouter]="true">
            <i nz-icon nzType="shopping-cart" nzTheme="outline"></i>
            <span>服务商品管理</span>
          </li>
          <li nz-menu-item routerLink="/home/serviceGoodsCodeManagement" [nzMatchRouter]="true">
            <i nz-icon nzType="barcode" nzTheme="outline"></i>
            <span>服务商品条码</span>
          </li>
          <li nz-menu-item routerLink="/home/serviceSkuManagement" [nzMatchRouter]="true">
            <i nz-icon nzType="tag" nzTheme="outline"></i>
            <span>服务SKU管理</span>
          </li>
          <li nz-menu-item routerLink="/home/serviceGoodsDetailImgManagement" [nzMatchRouter]="true">
            <i nz-icon nzType="picture" nzTheme="outline"></i>
            <span>服务详情图片</span>
          </li>
          <li nz-menu-item routerLink="/home/serviceGoodsDetailPropertyManagement" [nzMatchRouter]="true">
            <i nz-icon nzType="layout" nzTheme="outline"></i>
            <span>服务详情参数</span>
          </li>
        </ul>
      </li>
    </ul>
  </nz-sider>
  <nz-layout>
    <nz-header>
      <div class="header-content">
        <div class="header-left">
          <span class="back-btn" nz-icon nzType="arrow-left" nzTheme="outline" (click)="goBackToSystemSelection()"></span>
          <span class="back-text" (click)="goBackToSystemSelection()">返回系统选择</span>
          <span class="trigger" nz-icon
                [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
                (click)="isCollapsed = !isCollapsed"></span>
        </div>
        <div class="header-right">
          <i nz-icon nzType="user" nzTheme="outline"></i>
          <span>管理员</span>
        </div>
      </div>
    </nz-header>
    <nz-content>
      <nz-breadcrumb [nzAutoGenerate]="true" [nzRouteLabel]="'title'">
      </nz-breadcrumb>
      <div class="inner-content">
        <router-outlet/>
      </div>
    </nz-content>
    <nz-footer>
      <span>基本信息管理系统 ©2024 - Powered by Angular & Ant Design</span>
    </nz-footer>
  </nz-layout>
</nz-layout>
